namespace Gamification.Gamification {
    export interface ApiOperazioniForm {
        IdApiTipoOperazione: Serenity.LookupEditor;
        Nome: Serenity.StringEditor;
        Descrizione: Serenity.StringEditor;
    }

    export class ApiOperazioniForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ApiOperazioni';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ApiOperazioniForm.init)  {
                ApiOperazioniForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(ApiOperazioniForm, [
                    'IdApiTipoOperazione', w0,
                    'Nome', w1,
                    'Descrizione', w1
                ]);
            }
        }
    }
}
